import { Camera, Wifi, Monitor, HardDrive, WifiOff, Signal, Zap, Activity, AlertCircle } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const DEVICE_TYPES = [
  { id: 'ip_camera', label: 'IP Camera', icon: Camera },
  { id: 'wifi_camera', label: 'WiFi Camera', icon: Wifi },
  { id: 'nvr', label: 'NVR', icon: Monitor },
  { id: 'dvr', label: 'DVR', icon: HardDrive },
];

export const STREAM_TYPES = [
  { id: 'rtsp', label: 'RTSP' },
  { id: 'mjpeg', label: 'MJPEG' },
  { id: 'http', label: 'HTTP' },
  { id: 'hls', label: 'HLS' },
];

export const ALERT_TYPES = {
  offline: { label: 'Device Offline', icon: WifiOff, color: 'text-red-500' },
  weak_signal: { label: 'Weak Signal', icon: Signal, color: 'text-amber-500' },
  storage_full: { label: 'Storage Full', icon: HardDrive, color: 'text-orange-500' },
  firmware_update: { label: 'Firmware Update', icon: Zap, color: 'text-blue-500' },
  stream_unavailable: { label: 'Stream Error', icon: AlertCircle, color: 'text-red-500' },
  motion_detected: { label: 'Motion Detected', icon: Activity, color: 'text-purple-500' },
};
